import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getAuth } from "firebase/auth";
import { Firestore, enableIndexedDbPersistence, getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getFunctions } from 'firebase/functions';
import { getStorage, ref } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Safari (and Firefox) block third-party storage between premsi.com and
// *.firebaseapp.com. On the custom Hosting domain, use that same host as
// authDomain so Auth helpers load from /__/auth on premsi.com (same-origin).
const hostingAuthHosts = new Set(['premsi.com', 'www.premsi.com']);
const runtimeHost = typeof window !== 'undefined' ? window.location.hostname : '';
const authDomain = hostingAuthHosts.has(runtimeHost)
  ? runtimeHost
  : process.env.REACT_APP_FIREBASE_AUTHDOMAIN;

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain,
  databaseURL: process.env.REACT_APP_FIREBASE_DBURL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID
};

const app = initializeApp(firebaseConfig);

//https://firebase.google.com/docs/firestore/manage-data/enable-offline#web-modular-api_3
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

// Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
// key is the counterpart to the secret key you set in the Firebase console.
/*const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LfYGuEpAAAAAJL7xYVMKSEbKibI3Vzz8a-qC2Rj'),

  // Optional argument. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  isTokenAutoRefreshEnabled: true
});
*/
//export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app)
export const storage = getStorage(app);
export const storageRef = ref(storage);
export const analytics = getAnalytics(app)

logEvent(analytics, "testtt")

